import React, { useState } from 'react';
import { amazonAPI, handleAPIError } from '../api';

const Amazon = () => {
  const [processData, setProcessData] = useState({
    archivo_datos: '',
    parametros_procesamiento: {}
  });
  const [results, setResults] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const processAmazonData = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await amazonAPI.process(processData);
      
      if (response.success) {
        setResults(response.data);
      } else {
        setError('Error procesando datos de Amazon');
      }
    } catch (err) {
      const errorInfo = handleAPIError(err);
      setError(errorInfo.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="main-container">
      <div className="content-header">
        <h1 className="title-primary">Amazon Data Processor</h1>
        <p className="subtitle">Procesamiento y análisis de datos de Amazon</p>
      </div>

      <div className="card">
        <h2 className="title-secondary">Configuración</h2>
        <div style={{ marginBottom: '16px' }}>
          <label style={{ 
            display: 'block', 
            marginBottom: '8px', 
            color: 'var(--text-secondary)',
            fontWeight: 'var(--font-weight-medium)'
          }}>
            Archivo de Datos:
          </label>
          <input
            type="text"
            className="input-field"
            placeholder="Ruta del archivo de datos"
            value={processData.archivo_datos}
            onChange={(e) => setProcessData({...processData, archivo_datos: e.target.value})}
          />
        </div>
        
        <button 
          onClick={processAmazonData} 
          disabled={loading || !processData.archivo_datos}
          className="btn-primary"
          style={{
            opacity: (loading || !processData.archivo_datos) ? 0.6 : 1,
            cursor: (loading || !processData.archivo_datos) ? 'not-allowed' : 'pointer'
          }}
        >
          {loading ? 'Procesando...' : 'Procesar Datos'}
        </button>
      </div>

      {error && (
        <div className="message message-error">
          <p>{error}</p>
        </div>
      )}

      {results && (
        <div className="card">
          <h2 className="title-secondary">Resultados del Procesamiento</h2>
          <div className="description">
            <pre style={{ 
              backgroundColor: 'var(--bg-secondary)', 
              padding: '16px', 
              borderRadius: '8px',
              overflow: 'auto',
              color: 'var(--text-secondary)',
              fontSize: '14px'
            }}>
              {JSON.stringify(results, null, 2)}
            </pre>
          </div>
        </div>
      )}
    </div>
  );
};

export default Amazon; 